import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import merchantSettings from './modules/merchantSettings'
import logs from './modules/logs'
import appSettings from './modules/appSettings'
import transaction from './modules/transaction'
import signalRMessage from './modules/signalRMessage'
import consentMessage from './modules/consentMessage'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    merchantSettings,
    logs,
    appSettings,
    transaction,
    signalRMessage,
    consentMessage,
  },
  plugins: debug ? [createLogger()] : [],
})
